import Nav from 'react-bootstrap/Nav';
import { BarChartLineFill, GearFill, PeopleFill } from 'react-bootstrap-icons';
import { useAuth } from "./AuthProvider";
import { ADMIN, GAME_MASTER } from './Roles';
import { useTranslation } from 'react-i18next';

const Menu = () => {
    const auth = useAuth();
    const { t } = useTranslation();
    const show = auth.roles?.includes(ADMIN);

    if (!show) {
        return null;
    }

    return (
        <Nav defaultActiveKey="/games" className="flex-column menu-nav">
          <Nav.Link href="/games" className="d-flex align-items-center"><h5><BarChartLineFill className="me-2" /> {t('menu.games')}</h5></Nav.Link>
          {auth.roles.includes(ADMIN) && <Nav.Link href="/users" className="d-flex align-items-center"><h5><PeopleFill className="me-2" /> {t('menu.users')}</h5></Nav.Link>}
          <Nav.Link href="/settings" className="d-flex align-items-center"><h5><GearFill className="me-2" /> {t('menu.settings')}</h5></Nav.Link>
        </Nav>
      );
};

export default Menu;